//TODO: Break this out into different files. Just getting it wired up for now.
import ActionModel from '../models/ActionModel.js'
import Supers from './_supers'
import Specials from './_specials'
import Items from './_items'
import Naturals from './_naturals'
import {getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'

export default {
  "attack_generic-attack": {
    ...ActionModel,
    name: "Attack",
    description: "Standard thwack with a chance for bonus damage",
    category: "offense",
    affectTargetHpPoints: -1,
    ppCost: 0,
    increaseDangerMeterOnUse: 26, //bump for regular Attack on raising Danger Meter
    hasTimedHitBonusAvailable: true,
    getSuccessStep(actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        // getUseLine(casterModel.name, actionModel.name, ""),
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` attacks `,
            getColoredNameById(targetModel.id),
            `!`
          ]
        },
        {
          type: "animation",
          animationKey: "AnimationAttack",
          animationData: {
            casterId: casterModel.id,
            targetIds: targetModels.map(t => t.id)
          },
        }
      ]
    },
    getMissStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      const targetModel = targetModels[0];
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` attacks `,
            getColoredNameById(targetModel.id),
            `!`
          ]
        },
        {
          type: "message",
          content: [
            `...but it missed!`,
          ]
        }
      ]
    },

  },


  // "some-special-a": {
  //     ...ActionModel,
  //     name: "Attack Enemy Team",
  //     description: "Special A the enemy to bits.",
  //     affectTargetHpPoints: -4,
  //     targetType: "opponent-team",
  //     isSpecialAttack: true
  // },


  ...Supers,
  ...Specials,
  ...Items,
  ...Naturals

}


// WEBPACK FOOTER //
// ./src/battle/battle-data/battle-actions.js